<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	class="splash-loader-layer splash-loader-light"
	[ngStyle]="{ position: displayGlobally ? 'fixed' : 'absolute' }"
>
	<div class="centering-wrapper sl-icon">
		<div class="loading-checkmark"></div>
	</div>
	<div class="centering-wrapper sl-spinner no-spin">
		<div class="splash-spinner"></div>
	</div>
</div>
